const useStyles = ({ height }) => ({
  footer: {
    height: `${height}px`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#22467F',
    // color: 'white',
    // filter: 'brightness(0.85)',
    fontWeight: 200,
    fontSize: '.7em',
    position: 'sticky',
    bottom: 0,
    zIndex: 9999,
  },
  copy: {
    // padding: '0 40px',
    textAlign: 'center',
    color: 'white',
    textDecoration: 'none',
  },
  loginLink: {
    position: 'absolute',
    right: 0,
    marginRight: '10px',
    fontVariant: 'all-petite-caps',
    textDecoration: 'none',
    fontSize: '.9em',
    color: 'white',
  },
});

const Footer = ({ height }) => {
  const styles = useStyles({ height });
  return (
    <footer style={styles.footer}>
      <a href="https://broadband.masstech.org/" target="_blank" rel="noreferrer" style={styles.copy}>Ⓒ 2022 Massachusetts Broadband Institute</a>
      {/* <a href="https://appgeo.com" style={styles.loginLink}>Login</a> */}
    </footer>
  );
};

export default Footer;
